import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "property-behavior" }
const _hoisted_2 = {
  key: 0,
  class: "property-behavior-count"
}
const _hoisted_3 = {
  key: 1,
  class: "text-body-1 text-medium-emphasis"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_number_input = _resolveComponent("v-number-input")!
  const _component_ontos_pair_toggle = _resolveComponent("ontos-pair-toggle")!
  const _component_ontos_formula_input = _resolveComponent("ontos-formula-input")!
  const _component_ontos_choice_toggle = _resolveComponent("ontos-choice-toggle")!
  const _component_ontos_property_filling = _resolveComponent("ontos-property-filling")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.offersMultiple)
      ? (_openBlock(), _createBlock(_component_ontos_pair_toggle, _mergeProps({
          key: 0,
          "model-value": !!_ctx.model.multiple
        }, _ctx.pairs.multiple, {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('multiple', $event)))
        }), {
          default: _withCtx(() => [
            (_ctx.fillable && _ctx.kind !== 'mirror')
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.limits, (limit) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: limit.key,
                      class: "property-behavior-limit"
                    }, [
                      _createVNode(_component_v_switch, {
                        "model-value": _ctx.limited[limit.key],
                        label: _ctx.$tt(limit.label),
                        color: "primary",
                        density: "compact",
                        "hide-details": "",
                        "onUpdate:modelValue": ($event: any) => (_ctx.setLimited(limit.key, !!$event))
                      }, null, 8, ["model-value", "label", "onUpdate:modelValue"]),
                      (_ctx.limited[limit.key])
                        ? (_openBlock(), _createBlock(_component_v_number_input, {
                            key: 0,
                            "model-value": _ctx.numberOf(_ctx.model[limit.field]),
                            "onUpdate:modelValue": ($event: any) => (_ctx.setLimit(limit.key, $event)),
                            "onUpdate:focused": ($event: any) => (!$event && _ctx.$nextTick(() => _ctx.settle(limit.key))),
                            "aria-label": _ctx.$tt(limit.label),
                            min: _ctx.floorOf(limit.key),
                            max: _ctx.ceilingOf(limit.key),
                            precision: 0,
                            "control-variant": "split",
                            density: "compact",
                            "hide-details": "",
                            class: "property-behavior-number"
                          }, null, 8, ["model-value", "onUpdate:modelValue", "onUpdate:focused", "aria-label", "min", "max"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(limit.key === 'min' ? 0 : _ctx.$tt('unlimited')), 1))
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 16, ["model-value"]))
      : _createCommentVNode("", true),
    (_ctx.kind !== 'mirror' && _ctx.fillable)
      ? (_openBlock(), _createBlock(_component_ontos_choice_toggle, {
          key: 1,
          "model-value": _ctx.requiredMode,
          label: _ctx.pairs.required.label,
          options: _ctx.requiredOptions,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.setRequired($event)))
        }, _createSlots({ _: 2 }, [
          (_ctx.requiredMode === 'when' && _ctx.bindings)
            ? {
                name: "default",
                fn: _withCtx(() => [
                  _createVNode(_component_ontos_formula_input, _mergeProps({
                    ref: "requiredWhen",
                    class: "required"
                  }, _ctx.bindings, {
                    label: _ctx.$tt('pair.required-when'),
                    value: _ctx.model.requiredWhen || '',
                    condition: "requiredWhen",
                    draft: _ctx.conditionDraft,
                    "result-label": _ctx.booleanLabel,
                    example: _ctx.requiredWhenExample,
                    onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.model.requiredWhen = $event))
                  }), null, 16, ["label", "value", "draft", "result-label", "example"])
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["model-value", "label", "options"]))
      : _createCommentVNode("", true),
    (_ctx.offersUnique)
      ? (_openBlock(), _createBlock(_component_ontos_pair_toggle, _mergeProps({
          key: 2,
          "model-value": !!_ctx.model.unique
        }, _ctx.pairs.unique, {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.model.unique = $event))
        }), null, 16, ["model-value"]))
      : _createCommentVNode("", true),
    (_ctx.filledSingle && _ctx.offersIdentifier)
      ? (_openBlock(), _createBlock(_component_ontos_pair_toggle, _mergeProps({
          key: 3,
          "model-value": !!_ctx.model.identifier
        }, _ctx.pairs.identifier, {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.setIdentifier($event)))
        }), null, 16, ["model-value"]))
      : _createCommentVNode("", true),
    (_ctx.kind === 'relationship')
      ? (_openBlock(), _createBlock(_component_ontos_property_filling, {
          key: 4,
          model: _ctx.model,
          kind: "relationship",
          "compute-blocked": _ctx.computeBlocked
        }, null, 8, ["model", "compute-blocked"]))
      : _createCommentVNode("", true)
  ]))
}